// App-facing sim odds. Since 2026-10-16 the site shows the sim's RAW win rate: no Platt
// shrink toward 50% and no champion-incumbency edge. We're chasing the sim's actual behaviour
// against FFTBG's own build (tools/emu-battle), so the numbers on the page should be what the
// sim really produced: a team that won all 600 runs reads 100%, not ~75%.
// The fitted calibration (src/data/simCalibration.json: honest `a`, display `uiA`, `champEdge`)
// is unchanged and still used where honesty matters: the betting bot (it calls the pure
// calibrate() with those params) and tools/backtest.mjs --fit. To bring a calibrated display
// back, pass `params` (or `{ ...params, a: params.uiA }`) here instead of RAW.
import { calibrate as calibratePure, calibratedOdds as calibratedOddsPure } from './simCalibration.js';

const RAW = { a: 1, b: 0, champEdge: 0 };

export const calibrate = (rawP, opts = {}) => calibratePure(RAW, rawP, opts);
export const calibratedOdds = (res, opts = {}) => calibratedOddsPure(RAW, res, opts);
